import { ref } from 'vue'
import type { Coordinates } from './locationTypes'

export function useGps() {
    const lastFetchedCoords = ref<Coordinates | null>(null)

    const getLocationOnce = (): Promise<Coordinates> =>
        new Promise((resolve, reject) => {
            const { getCurrentLocation, emitter } = useLocationFinder()

            const timeout = setTimeout(() => {
                cleanup()
                reject(new Error('Location request timed out. Please try again.'))
            }, 10000)

            const onSuccess = (coords: any) => {
                cleanup()
                resolve(coords)
            }

            const onError = (err: any) => {
                cleanup()
                reject(err)
            }

            const cleanup = () => {
                clearTimeout(timeout)
                emitter.off('success', onSuccess)
                emitter.off('error', onError)
            }

            emitter.on('success', onSuccess)
            emitter.on('error', onError)

            getCurrentLocation()
        })

    const getCurrentGpsCoords = async () => {
        if (lastFetchedCoords.value) return lastFetchedCoords.value
        const coords = await getLocationOnce()
        lastFetchedCoords.value = coords
        return coords
    }

    const getLocationOnceSafe = async (): Promise<Coordinates | null> => {
        try {
            const coords = await getLocationOnce()
            return coords
        } catch (err) {
            console.warn('[GPS] Failed to get location:', err)
            return null
        }
    }

    return {
        getLocationOnce,
        getCurrentGpsCoords,
        getLocationOnceSafe,
        lastFetchedCoords
    }
}
